import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgView = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.99997 4.84455C6.92073 4.79261 3.73608 6.94448 1.73393 9.1483C1.52377 9.38161 1.40747 9.6845 1.40747 9.99851C1.40747 10.3125 1.52377 10.6154 1.73393 10.8487C3.69254 13.0059 6.86803 15.2075 9.99997 15.1548C13.1319 15.2075 16.3082 13.0059 18.2683 10.8487C18.4785 10.6154 18.5948 10.3125 18.5948 9.99851C18.5948 9.6845 18.4785 9.38161 18.2683 9.1483C16.2639 6.94448 13.0792 4.79261 9.99997 4.84455Z",
		stroke: "#8C94AA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.8644 9.99999C12.8643 10.5665 12.6961 11.1203 12.3813 11.5913C12.0664 12.0622 11.619 12.4293 11.0955 12.646C10.5721 12.8627 9.99614 12.9193 9.44052 12.8087C8.88489 12.6981 8.37454 12.4252 7.974 12.0245C7.57346 11.6239 7.30071 11.1135 7.19024 10.5578C7.07977 10.0021 7.13655 9.42621 7.35338 8.90282C7.57022 8.37943 7.93738 7.93209 8.40844 7.61736C8.8795 7.30263 9.43331 7.13464 9.99984 7.13464C10.3761 7.13454 10.7487 7.2086 11.0964 7.35257C11.444 7.49654 11.7599 7.70761 12.0259 7.97371C12.2919 8.23981 12.5029 8.55573 12.6468 8.90341C12.7907 9.25109 12.8646 9.62372 12.8644 9.99999Z",
		stroke: "#8C94AA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgView);
export default ForwardRef;
